<template>
  <div>
    <!-- <div class="mettes">

      <div class="table">
        <div>
          <div
            v-for="(item,index) in labledata"
            :key="index"
            :class="{heightlight : lableindex==index}"
            @click="lableArea(index,item)"
          >{{item}}</div>
        </div>
        <div>
          <el-table :data="tableData" border style="width: 100%">
            <el-table-column prop="createName" label="作者" width="180"></el-table-column>
            <el-table-column prop="fileName" label="作品名称"></el-table-column>
            <el-table-column label="状态" width="100">
              <template slot-scope="scope">
                <span v-if="scope.row.isPj==false">
                  <el-tag type="info">未评分</el-tag>
                </span>
                <span v-else-if="scope.row.isPj==true">
                  <el-tag type="success">已评分</el-tag>
                </span>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="100">
              <template slot-scope="scope">
                <el-button @click="handleClick(scope.row.id)" type="text" size="small">立即评分</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="pagination">
          <el-pagination
            v-if="listQuery.limit>10"
            background
            prev-text="上一页"
            next-text="下一页"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="listQuery.page"
            :page-size="listQuery.limit"
            layout=" total,prev, pager, next,jumper"
            :total="listQuery.count"
          ></el-pagination>
        </div>
      </div>
    </div>-->

    <!-- <el-dialog :visible.sync="dialogVisible" width="60%">
      <div class="veidoORifame">
        <iframe :src="persondata.fileUrl" frameborder="0"></iframe>
      </div>
      <div class="formtable">
        <el-form :model="activityForm" ref="activityForm" label-width="100px" class="demo-ruleForm">
          <el-form-item label="评分指标">
            <div
              style="display:flex;width:750px;text-align: center;background-color: rgb(4, 150, 235);height:50px;line-height:50px;color:#fff"
            >
              <div style="flex:1">指标项</div>
              <div style="flex:5">指标要求</div>
              <div style="flex:1">分值</div>
              <div style="flex:1">评分</div>
            </div>
       
            <div v-if="persondata.isPj==false">
              <div v-for="(item, index) in knowledgeItems" :key="index">
                <div
                  style="display:flex;width:748px;text-align: center;height:50px;line-height:50px;border:solid 1px #ccc;
                                    "
                >
                  <div style="flex:1">{{index+1}}</div>
                  <div style="flex:5">{{item.name}}</div>
                  <div style="flex:1">{{item.score}}</div>
                  <div style="flex:1">
                    <el-input
                      style="margin-bottom: 5px; margin-right: 5px"
                      type="number"
                      v-model="item.indexscore"
                      @blur="oninput(item.score,item.indexscore,index)"
                    ></el-input>
                  </div>
                </div>
              </div>
            </div>
            <div v-else>
          
              <div v-for="(item, index) in knowledgeItems" :key="index">
                <div
                  style="display:flex;width:748px;text-align: center;height:50px;line-height:50px;border:solid 1px #ccc;
                                    "
                >
                  <div style="flex:1">{{index+1}}</div>
                  <div style="flex:5">{{item.name}}</div>
                  <div style="flex:1">{{item.realScore}}</div>
                  <div style="flex:1">
                    <el-input
                      style="margin-bottom: 5px; margin-right: 5px"
                      type="number"
                      v-model="item.score"
                      @blur="oninput(item.realScore,item.score,index)"
                    ></el-input>
                  </div>
                </div>
              </div>
            </div>
          </el-form-item>
          <el-form-item label="作品得分">
            <el-input v-model="sum" style="width:300px" :disabled="true"></el-input>
          </el-form-item>

          <el-form-item label="评语">
            <el-input type="textarea" v-model="persondata.pjContent" style="width:700px"></el-input>
          </el-form-item>
        </el-form>
      </div>

      <div class="pagination">
        <el-button type="primary" @click="submit">保存</el-button>
        <el-button @click="dialogVisible = false">取 消</el-button>
      </div>
    </el-dialog>-->

    <div class="veidoORifame">
      <iframe :src="persondata.fileUrl" frameborder="1"></iframe>
    </div>
    <div class="formtable">
      <el-form :model="activityForm" ref="activityForm"  class="demo-ruleForm">
        <el-form-item>
          <div
            style="display:flex;width:100%;text-align: center;background-color: rgb(4, 150, 235);height:50px;line-height:50px;color:#fff"
          >
            <div style="flex:1">指标项</div>
            <div style="flex:1">分值</div>
            <div style="flex:8">指标要求</div>
            <div style="flex:2">评分</div>
          </div>
          <!-- v-if如果以前没有评价过点进来获取空的数值 -->
          <div v-if="persondata.isPj==false">
            <div v-for="(item, index) in knowledgeItems" :key="index">
              <div
                style="display:flex;width:100%;text-align: center;height:50px;line-height:50px;border:solid 1px #ccc;
                                    "
              >
                <div style="flex:1">{{index+1}}</div>
                <div style="flex:1">{{item.score}}</div>
                <div style="flex:8">{{item.name}}</div>
                <div style="flex:2">
                  <el-input
                    style="margin-bottom: 5px; margin-right: 5px;width: 160px;"
                    type="number"
                    v-model="item.indexscore"
                    @blur="oninput(item.score,item.indexscore,index)"
                  ></el-input>
                </div>
              </div>
            </div>
          </div>
          <div v-else>
            <!-- v-else如果评分过进来改评分需获取原有的改分，接口不完善后续判断 -->
            <div v-for="(item, index) in knowledgeItems" :key="index">
              <div
                style="display:flex;width:100%;text-align: center;height:50px;line-height:50px;border:solid 1px #ccc;
                                    "
              >
                <div style="flex:1">{{index+1}}</div>
                <div style="flex:1">{{item.realscore}}</div>
                <div style="flex:8">{{item.name}}</div>
                <div style="flex:2">
                  <el-input
                    style="margin-bottom: 5px; margin-right: 5px;width: 160px;"
                    type="number"
                    v-model="item.score"
                    @blur="oninput(item.realscore,item.score,index)"
                  ></el-input>
                </div>
              </div>
            </div>
          </div>
        </el-form-item>
        <el-form-item >
         <div class="flex-box">
            <div>
              总分：<el-input v-model="sum" style="width:300px" :disabled="true"></el-input>
            </div>
            <div v-if="persondata.ruleUrl">
               附件：<a :href="persondata.ruleUrl" class="a-style" download >详细评分指标</a>
            </div>
         </div>
        </el-form-item>

        <el-form-item >
          评语：
          <el-input type="textarea" :rows="6" placeholder="评语" v-model="persondata.pjContent" ></el-input>
        </el-form-item>

        <el-form-item label-width="550px" v-if="isSubmit">
          <el-button type="primary" v-if="!persondata.isPj"  @click="submit"> 提交评分结果</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>
<script>
import vsmallheader from '@/views/smallHeader/index';
import * as personcen from '@/api/personcenter/index.js';
export default {
  props: ['crderId'],
  components: {
    vsmallheader,
  },
  data() {
    return {
      dialogVisible: false,
      currentPage2: 1,
      labledata: ['未完成', '已完成'],
      lableindex: 0,
      activityForm: {
        indexscore: null,
        totalPoints: null,
        remark: '',
      },
      listQuery: {
        page: 1,
        limit: 10,
        count: 0,
        activityId: 0,
      },
      persondata: [],
      knowledgeItems: [],
      tableData: [],
      isSubmit:true
    };
  },
  computed: {
    sum() {
      if (this.persondata.isPj == false) {
        return this.knowledgeItems.reduce((total, value) => {
          return Number.isNaN(parseFloat(value.indexscore))
            ? total
            : total + parseFloat(value.indexscore);
        }, 0);
      } else {
        return this.knowledgeItems.reduce((total, value) => {
          return Number.isNaN(parseFloat(value.score))
            ? total
            : total + parseFloat(value.score);
        }, 0);
      }
    },
  },
  mounted() {
    // console.log(this.sum)
  },
  created() {
    // this.getlist();
    this.activityid=this.$route.query.activityid
    if(this.$route.query.ispj){
      this.isSubmit=false
      
    }
    this.getonereslist(this.crderId);
  },
  methods: {
    // onInputFocus(val){
    //     // debugger
    // },
    oninput(val, aaa, index) {
      // val为分值的大小，aaa是输入框的数值，index是哪个输入框的索引
      if (this.persondata.isPj == false) {
        if (aaa > val) {
          aaa = val;
          this.knowledgeItems[index].indexscore = val;
          this.$message({
            message: '警告哦，输入框的值不能大于分值',
            type: 'warning',
          });
        } else if (aaa < 0) {
          this.knowledgeItems[index].indexscore = 0;
          this.$message({
            message: '警告哦，输入框的值不能小于零',
            type: 'warning',
          });
        }
      } else {
        if (aaa > val) {
          aaa = val;
          this.knowledgeItems[index].score = val;
          this.$message({
            message: '警告哦，输入框的值不能大于分值',
            type: 'warning',
          });
        } else if (aaa < 0) {
          this.knowledgeItems[index].score = 0;
          this.$message({
            message: '警告哦，输入框的值不能小于零',
            type: 'warning',
          });
        }
      }
    },
    getlist() {
      this.listQuery.activityId = this.GradeId;
      personcen.LoadActivityResource(this.listQuery).then((res) => {
        this.tableData = res.data;
        this.listQuery.count = res.count;
      });
    },
    retrun() {
      this.$router.push('/personCenter/task');
    },
    lableArea(index, item) {
      this.lableindex = index;
    },
    handleSizeChange(val) {
      this.listQuery.limit = val;
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.listQuery.page = val;
      this.getlist();
    },
    handleClick(id) {
      this.dialogVisible = true;
      localStorage.setItem('resourceId', id);
      this.getonereslist(id);
    },
    //获取活动单个人的活动资料
    getonereslist(personid) {
      personcen.GetActivityResource({ id: personid }).then((res) => {
        console.log(res.result);
        this.persondata = res.result;
        if (this.persondata.isPj == false) {
          this.knowledgeItems = [];
          this.GetRuleActivityInfo(this.activityid);
        } else {
          this.knowledgeItems = [];
          this.GetScoreActivityResource(personid);
        }
      });
    },
    //获取活动的评分标准
    GetRuleActivityInfo(personid){
      personcen
        .GetRuleActivityInfo({ activityId: this.activityid })
        .then((res) => {
          this.knowledgeItems = res.result;
          // this.knowledgeItems.forEach(element => {
          //     element.indexscore=0
          // });
          console.log(this.knowledgeItems);
        });
    },
    GetScoreActivityResource(personid) {
      personcen.GetScoreActivityResource({ id: personid }).then((res) => {
        this.knowledgeItems = res.result;
        console.log(this.knowledgeItems);
        debugger
      });
    },
    // 提交保存
    submit() {
      if (this.persondata.isPj == false) {
        //评分上传接口
        let arr = [];
        this.knowledgeItems.forEach((element) => {
          let obj = {
            resourceId: this.$route.query.id,
            ruleId: 0,
            score: 0,
          };
          obj.ruleId = element.id;
          obj.score = element.indexscore * 1;
          arr.push(obj);
        });
        //添加
        console.log(arr);
        personcen.AddScoreActivityResource(arr).then((res) => {
          this.$notify({
            title: '成功',
            message: '上传成功',
            type: 'success',
          });
          localStorage.removeItem('resourceId');
          this.dialogVisible = false;
        });
      } else {
        //评分上传接口
        this.knowledgeItems.forEach((element) => {
          // let obj={
          //     resourceId:localStorage.getItem("resourceId")*1,
          //     ruleId:0,
          //     score:0
          // }
          this.knowledgeItems.ruleId = element.id;
          this.knowledgeItems.score = element.score * 1;
          // arr.push(this.knowledgeItems)
        });
        //修改
        personcen
          .UpdateScoreActivityResource(this.knowledgeItems)
          .then((res) => {
            this.$notify({
              title: '成功',
              message: '上传成功',
              type: 'success',
            });
            localStorage.removeItem('resourceId');
            this.dialogVisible = false;
          });
      }

      //评语总分上传
      this.persondata.score = this.sum;
      console.log(this.sum);
      this.persondata.isPj = true;
      this.persondata.pjUserName = JSON.parse(
        this.$store.state.User.infos
      ).name;
      let para = this.persondata;
      console.log(para);
      personcen.UpdateActivityResource(para).then((res) => {
        this.getlist();
        this.getonereslist(this.crderId);
        this.$router.go(-1)
      });
    },
  },
};
</script>
<style scoped>
.a-style{
  color:#66b1ff;

}
.a-style:hover{
  text-decoration:underline;
  cursor: pointer;
}
.flex-box{
  display: flex;
  justify-content: space-between;
  padding-right: 50px;
}
.v-modal {
  z-index: 0 !important;
}
.mettes {
  /* width: 1200px; */
  margin: 0 auto;
  /* height: 720px; */
  /* box-shadow: 2px 2px 5px rgba(215, 215, 215, 0.968627450980392); */
  /* margin-top: 30px; */
  /* margin-bottom: 30px; */
  /* border-radius: 5px; */
}
.pagination {
  margin-top: 20px;
  text-align: center;
}
.header {
  padding: 4px 8px;
  font-size: 16px;
  color: #fff;
  background-color: #02a7f0;
  border-radius: 5px;
  cursor: pointer;
}
.table {
  /* width: 1000px; */
  margin: 0 auto;
  /* height: 100px; */
}
.heightlight {
  color: #409eff !important;
}
.table > div:nth-child(1) {
  display: flex;
  margin-top: 10px;
}
.table > div:nth-child(1) > div {
  cursor: pointer;
  margin-left: 5px;
  padding: 3px 5px;
  font-size: 16px;
}
.table > div:nth-child(2) {
  /* height: 550px; */
}
.veidoORifame {
  margin: 0 auto;
  height: 500px;
  background-color: #aaaaaa0d;
}
.veidoORifame > iframe {
  width: 100%;
  height: 100%;
}
.formtable {
  /* width: 1000px; */
  margin: 0 auto;
  margin-top: 30px;
}
/deep/.el-dialog__header {
  height: 0px;
}
</style>